import { h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import Container from "../../components/container";
import { TextHeader } from "../../components/text";
import { COULMN_DATA } from "./constants/columns";
import { useGetData } from "./hook/useGetData";
import {
  ContainerData,
  ContainerSearch,
  ContainerTable,
  DivButtonExportFile,
} from "./style/style";
import { TableData } from "./view/table/data";
import { useDelete } from "./hook/useDelete";
import { useGetOption } from "./hook/useGetOption";
import { useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import qurrystring from "query-string";
import { PrimaryButton } from "../../components/button/primary";
import { SecondaryButton } from "../../components/button/secondary";
import { Divider } from "antd";
import BaseForm from "../../components/form";
import Summary from "./view/summary";
import { compairStatus, convertDateTime } from "../../functions";
import { EditData } from "./view/modal/edit";
import { IModelRef } from "./interfaces/modal";
import { IStateChangeReservation, IStateReservation } from "./interfaces/state";
import { FORM_SEARCH } from "./constants/form";
import WrapperComponent from "../../components/hoc/WrapperComponent";
import { HEADERS } from "./constants/exportexcel";
import { ButtonCSV } from "../../components/button/buttonCSV";

const ReservationScene = () => {
  let modalRef = useRef<IModelRef>();
  const { onDelete } = useDelete();
  const { onFetchOptionsReserve, optionsReserve } = useGetOption();
  const { data, setData, onFetchData, onSearch } = useGetData();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const pl = params.get("p");
  const [loadingTable, setLoadingTable] = useState(false);
  const [forceLoadingSearch, setForceLoadingSearch] = useState(false);
  const [forceLoading, setForceLoading] = useState(false);
  const { control, setValue, getValues, reset, handleSubmit } = useForm({});

  useEffect(() => {
    const firstFetchData = async () => {
      setLoadingTable(true);
      await onFetchData();
      setLoadingTable(false);
    };
    firstFetchData();
    onFetchOptionsReserve();
  }, []);

  useEffect(() => {
    onFetchSearch();
  }, [pl]);

  const onFetchSearch = async () => {
    setLoadingTable(true);
    pl && (await onSearch(pl));
    setForceLoading(false);
    setLoadingTable(false);
  };

  const onSubmitSearch = async () => {
    const {
      search_reserveId,
      search_customerCode,
      search_reserveDate,
      search_reservationOption,
      search_saleCode,
    } = getValues();
    const valueParams = {
      reserveId: search_reserveId,
      reserveStatus: search_reservationOption,
      date: search_reserveDate && convertDateTime(search_reserveDate),
      saleCode: search_saleCode,
      customerCode: search_customerCode,
    };
    const queryString = qurrystring.stringify(valueParams);
    setForceLoadingSearch(true);
    setLoadingTable(true);
    window.history.replaceState(null, "", `reservation?${queryString}`);
    await onSearch(queryString);
    setLoadingTable(false);
    setForceLoadingSearch(false);
  };

  const onSubmitClearSearch = async (force?: boolean) => {
    reset();
    const {
      search_reserveId,
      search_customerCode,
      search_reserveDate,
      search_reservationOption,
      search_saleCode,
    } = getValues();
    const valueParams = {
      reserveId: search_reserveId,
      reserveStatus: search_reservationOption,
      date: search_reserveDate && convertDateTime(search_reserveDate),
      saleCode: search_saleCode,
      customerCode: search_customerCode,
    };
    const queryString = qurrystring.stringify(valueParams);
    force && setForceLoading(true);
    setLoadingTable(true);
    window.history.replaceState(null, "", `reservation?${queryString}`);
    await onFetchData();
    setLoadingTable(false);
    force && setForceLoading(false);
  };

  const onCallbackEdit = async (item: IStateReservation) => {
    const { saleOrder, invoiceId, saleLotId, customerCode, reserveTypeId } =
      item;
    const findIndex = data.findIndex((e) => e.reserveId === item.reserveId);
    if (findIndex === -1) {
      return;
    }
    const d = JSON.parse(JSON.stringify(data)) as IStateReservation[];
    d[findIndex].reserveStatusId = "STRH-100";
    d[findIndex].saleOrder = saleOrder;
    d[findIndex].invoiceId = invoiceId;
    d[findIndex].saleLotId = saleLotId;
    d[findIndex].customerCode = customerCode;
    d[findIndex].reserveTypeId = reserveTypeId;
    // เงื่อนไข (reserveType) แก้ไม่ได้ในหน้านี้แล้ว → ใช้ค่าเดิมจาก GetAll (tm.TypeName) ไม่ต้อง re-derive
    if (invoiceId === null || invoiceId === "") {
      d[findIndex].reserveStatusId = "STRH-002";
    }
    if (saleOrder === null || saleOrder === "") {
      d[findIndex].reserveStatusId = "STRH-001";
    }
    setData(d);
  };

  const onCallbackDelete = async (item: IStateReservation) => {
    const findIndex = data.findIndex((e) => e.reserveId === item.reserveId);
    if (findIndex === -1) {
      return;
    }
    const d = JSON.parse(JSON.stringify(data)) as IStateReservation[];
    const { reserveId } = d[findIndex];
    const r = await onDelete(`${reserveId}`);
    if (!r) {
      return;
    }
    d.splice(findIndex, 1);
    setData(d.map((e, i) => ({ ...e, index: i + 1 })));
  };

  const compairData = data.map((e: any) => ({
    ...e,
    reserveStatusId: compairStatus(e.reserveStatusId),
  }));

  return (
    <Container>
      <TextHeader text={"การจองสินค้า"} divider={true} />
      <Summary data={data} />
      <Divider />
      <ContainerData>
        <BaseForm
          control={control}
          forms={FORM_SEARCH({ onSubmitSearch, optionsReserve })}
          setValue={setValue}
          getValues={getValues}
        />
        <ContainerSearch>
          <PrimaryButton
            label={"ค้นหา"}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ margin: "5px" }}
            tabletStyle={{ margin: "5px" }}
            isLoading={forceLoadingSearch}
            forceLoading={forceLoadingSearch}
            onPress={handleSubmit(onSubmitSearch)}
          />
          <SecondaryButton
            label={"ล้างข้อมูล"}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ margin: "5px" }}
            tabletStyle={{ margin: "5px" }}
            isLoading={forceLoadingSearch}
            forceLoading={forceLoading}
            onPress={onSubmitClearSearch}
          />
        </ContainerSearch>
      </ContainerData>
      <Divider />
      <ContainerTable>
        <DivButtonExportFile>
          <ButtonCSV
            label={"Export"}
            data={compairData}
            header={HEADERS}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ margin: "5px" }}
            tabletStyle={{ margin: "5px" }}
            fileName={"Exportreversation.csv"}
          />
        </DivButtonExportFile>
        <TableData
          columns={COULMN_DATA({
            onEdit: (e: IStateReservation) =>
              modalRef.current && modalRef.current.openModal(e),
            onDelete: (e: IStateReservation) => onCallbackDelete(e),
          })}
          data={data}
          loading={loadingTable}
        />
      </ContainerTable>
      <EditData
        ref={modalRef}
        onCallbackEdit={(e: IStateChangeReservation) => onCallbackEdit(e)}
      />
    </Container>
  );
};

export default WrapperComponent("ReservationScene")(ReservationScene);
